import React, { useState } from 'react';
import Heading from "@scentregroup/ui/components/heading";
import TradingHoursLine from '../trading-hours-line';
import { parseCentreOpeningHours } from '../../helpers/parse-opening-hours';
import { Box } from '@hub/box';
import { Button } from '@hub/button';
import { ChevronDownSmallIcon, ChevronUpSmallIcon } from '@hub/icon';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function hasHours(centreTradingHours) {
  return Boolean(centreTradingHours) && Boolean(centreTradingHours.tradingHours) && Boolean(centreTradingHours.timeZone);
}
const TradingHoursList = _ref => {
  let {
    heading,
    openHoursHeading,
    openDaysHeading,
    centreTradingHours,
    minDays
  } = _ref;
  const {
    0: showMoreOpeningHours,
    1: setShowMoreOpeningHours
  } = useState(false);
  if (!hasHours(centreTradingHours)) {
    return null;
  }
  const openHours = parseCentreOpeningHours(centreTradingHours.tradingHours, centreTradingHours.timeZone, centreTradingHours.features);
  const hasColumnHeading = Boolean(openDaysHeading || openHoursHeading);
  const tradingHoursLines = openHours.map(hours => /*#__PURE__*/_jsx(TradingHoursLine, {
    openHourDay: hours,
    sx: {
      justifyContent: 'space-between'
    },
    hoursSx: {
      width: 'size-15'
    },
    "data-id": "trading-hours-list_index_tradingHoursLines_TradingHoursLine"
  }, hours.day));
  const ChevronSmallIcon = showMoreOpeningHours ? ChevronUpSmallIcon : ChevronDownSmallIcon;
  return /*#__PURE__*/_jsxs("div", {
    "data-id": "trading-hours-list_index_tradingHoursLines_div",
    children: [heading && /*#__PURE__*/_jsx(Heading, {
      type: "medium",
      "data-id": "trading-hours-list_index_tradingHoursLines_Heading",
      children: heading
    }), /*#__PURE__*/_jsxs("div", {
      className: style.TradingHoursList,
      "data-id": "trading-hours-list_index_tradingHoursLines_div_div",
      children: [hasColumnHeading && /*#__PURE__*/_jsxs("div", {
        className: style.tableHeading,
        "data-id": "trading-hours-list_index_tradingHoursLines_div_4",
        children: [/*#__PURE__*/_jsx("div", {
          "data-id": "trading-hours-list_index_tradingHoursLines_div_div_5",
          children: openDaysHeading && /*#__PURE__*/_jsx(Heading, {
            type: "extrasmall",
            className: style.day,
            "data-id": "trading-hours-list_index_tradingHoursLines_Heading",
            children: openDaysHeading
          })
        }), /*#__PURE__*/_jsx("div", {
          "data-id": "trading-hours-list_index_tradingHoursLines_div_div",
          children: openHoursHeading && /*#__PURE__*/_jsx(Heading, {
            type: "extrasmall",
            className: style.hours,
            "data-id": "trading-hours-list_index_tradingHoursLines_Heading",
            children: openHoursHeading
          })
        })]
      }), showMoreOpeningHours ? tradingHoursLines : tradingHoursLines.slice(0, minDays), /*#__PURE__*/_jsx(Box, {
        "data-id": "trading-hours-list_index_tradingHoursLines_div_Box",
        children: /*#__PURE__*/_jsxs(Button, {
          type: "button",
          variant: "transparent",
          colorScheme: "licorice",
          onClick: () => setShowMoreOpeningHours(!showMoreOpeningHours),
          rightIcon: /*#__PURE__*/_jsx(ChevronSmallIcon, {
            sx: {
              width: 'size-icon-sm',
              height: 'size-icon-sm',
              color: 'licorice'
            },
            "data-id": "trading-hours-list_index_tradingHoursLines_ChevronSmallIcon"
          }),
          "data-id": "trading-hours-list_index_tradingHoursLines_Box_Button",
          children: ["see ", showMoreOpeningHours ? 'less' : 'more', " opening hours"]
        })
      })]
    })]
  });
};
export default TradingHoursList;